import { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"

export default function LoginPage() {

  const [password, setPassword] = useState("")
  const navigate = useNavigate()

  // 🔥 AUTO REDIRECT SE GIÀ LOGGATO
  useEffect(() => {
    const admin = localStorage.getItem("isAdmin")
    if (admin === "true") {
      navigate("/trattamenti")
    }
  }, [navigate])

  const handleLogin = () => {

    if (password === "Alkimyad3sk") {
      localStorage.setItem("isAdmin", "true")
      navigate("/trattamenti")
    } else {
      alert("Password errata")
    }

  }

  return (
    <div className="h-screen flex items-center justify-center bg-[#f8f5f1]">

      <div className="bg-white p-10 rounded-2xl shadow-xl w-[350px]">

        <h2 className="text-2xl font-semibold mb-6 text-center">
          Accesso Admin
        </h2>

        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full mb-4 px-4 py-3 border rounded-lg focus:outline-none"
        />

        <button
          onClick={handleLogin}
          className="w-full bg-black text-white py-3 rounded-lg hover:opacity-90 transition"
        >
          Accedi
        </button>

      </div>

    </div>
  )
}